<div class="popup-content gg-popup-content-text" *ngIf="!customContent; else customContentTpl">
  {{ config.textContent }}
</div>

<ng-template #customContentTpl>
  <ng-content select="[ggCustomPopupContent]"></ng-content>
</ng-template>
